var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 117,
    viewBox: "0 0 224 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2007_1230)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00195312,
    width: 224,
    height: 117,
    rx: 8,
    fill: "#14170E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2007_1230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 151,
    cy: 112.502,
    rx: 73,
    ry: 85.5,
    fill: "#10C237"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.382 62.855V49.66H33.427V62.884C33.427 63.522 33.2723 64.073 32.963 64.537C32.7503 64.827 32.412 65.2136 31.948 65.697C31.5033 66.161 31.136 66.4703 30.846 66.625C30.2853 66.973 29.6957 67.147 29.077 67.147H25.394C24.756 67.147 24.1567 66.973 23.596 66.625C23.3253 66.4703 22.9483 66.161 22.465 65.697C22.001 65.2136 21.6723 64.827 21.479 64.537C21.1697 64.073 21.015 63.522 21.015 62.884V49.66H24.06V62.826C24.06 62.9033 24.0697 62.9516 24.089 62.971C24.495 63.5703 24.9203 63.986 25.365 64.218L25.51 64.247H28.961C29.019 64.247 29.0673 64.2373 29.106 64.218C29.5507 63.986 29.9663 63.5703 30.353 62.971L30.382 62.855ZM50.1799 62.884C50.1799 63.5606 50.0253 64.1116 49.7159 64.537C49.5226 64.827 49.1939 65.2136 48.7299 65.697C48.2659 66.161 47.8889 66.4703 47.5989 66.625C46.9803 66.973 46.3809 67.147 45.8009 67.147H40.7549C39.4983 67.147 38.2706 66.3446 37.0719 64.74C36.9559 64.5853 36.7819 64.2856 36.5499 63.841L39.4209 62.884C39.8076 63.4253 40.2329 63.87 40.6969 64.218C40.7356 64.2373 40.8033 64.247 40.8999 64.247H45.6559L45.8299 64.218C46.0426 64.102 46.3133 63.8796 46.6419 63.551C46.9706 63.2223 47.1349 63 47.1349 62.884V61.173C47.1349 60.883 47.0189 60.7186 46.7869 60.68L39.2469 58.534C38.5316 58.3406 37.9709 57.9443 37.5649 57.345C37.1783 56.7456 36.9849 56.0883 36.9849 55.373V53.807C36.9849 53.1303 37.1299 52.5793 37.4199 52.154C37.6133 51.8833 37.9419 51.516 38.4059 51.052C38.8893 50.5686 39.2759 50.24 39.5659 50.066C40.1846 49.718 40.7839 49.544 41.3639 49.544H45.6559C46.8933 49.544 48.1209 50.3463 49.3389 51.951C49.5323 52.2216 49.7256 52.56 49.9189 52.966L46.9899 53.807C46.5453 53.169 46.1199 52.7243 45.7139 52.473C45.6946 52.4536 45.6366 52.444 45.5399 52.444H41.4509L41.2769 52.473C41.0449 52.589 40.7743 52.8016 40.4649 53.111C40.1749 53.4203 40.0299 53.633 40.0299 53.749V55.199C40.0299 55.489 40.1363 55.6533 40.3489 55.692L47.9179 57.896C48.6139 58.0893 49.1649 58.4953 49.5709 59.114C49.9769 59.7133 50.1799 60.361 50.1799 61.057V62.884ZM64.8333 67.002H53.9293V49.66H64.8333V52.56H56.9743V56.939H64.2823V59.839H56.9743V64.102H64.8333V67.002ZM81.1784 56.214C81.1784 56.8713 81.0044 57.461 80.6564 57.983C80.5211 58.1763 80.2794 58.447 79.9314 58.795C79.5834 59.1236 79.3031 59.3653 79.0904 59.52C78.8391 59.7133 78.5878 59.8486 78.3364 59.926L81.7874 67.002H78.4814L75.2624 60.158H71.9274V67.002H68.8824V49.66H77.0314C77.8048 49.66 78.4911 49.8726 79.0904 50.298C79.2838 50.4333 79.5544 50.6846 79.9024 51.052C80.2698 51.4193 80.5211 51.6996 80.6564 51.893C81.0044 52.415 81.1784 53.0046 81.1784 53.662V56.214ZM78.1334 56.185V53.691C78.1334 53.5943 78.1238 53.5266 78.1044 53.488C77.7758 52.908 77.4664 52.5986 77.1764 52.56H71.9274V57.258H77.0314C77.1668 57.258 77.3504 57.1516 77.5824 56.939C77.8144 56.7263 77.9884 56.5136 78.1044 56.301C78.1238 56.2623 78.1334 56.2236 78.1334 56.185Z",
    fill: "#10C237"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.50195,
    width: 221,
    height: 114,
    rx: 6.5,
    stroke: "#10C237",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2007_1230",
    x: 8.97088,
    y: -42.0272,
    width: 284.058,
    height: 309.058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5146,
    result: "effect1_foregroundBlur_2007_1230"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2007_1230"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00195312,
    width: 224,
    height: 117,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCard);
export default __webpack_public_path__ + "static/media/UserCard.9a686067c626619807a6a04ddfe00164.svg";
export { ForwardRef as ReactComponent };